import React from "react";

import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import { Box, Collapse, IconButton, Stack, Typography } from "@mui/material";

const chevronColor = "#0A3142";
const labelColor = "#20293C";

interface Props {
  title: string;
  icon?: React.ReactNode;
  isOpen: boolean;
  onArrowClick: () => void;
  onTitleClick: () => void;
  children?: React.ReactNode;
  availableHeight?: number;
  isActive: boolean;
}

export const Accordion: React.FC<Props> = ({
  title,
  icon,
  isOpen,
  onArrowClick,
  onTitleClick,
  children,
  availableHeight,
  isActive
}) => {
  return (
    <Stack
      sx={{
        width: "100%",
        minHeight: 36
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          flexShrink: 0,
          height: "36px",
          padding: "0 5px",
          borderRadius: "20px",
          cursor: "pointer",
          backgroundColor: isActive ? "#DBE8F5" : "transparent",
          "&:hover": {
            backgroundColor: "#ECF1F8"
          }
        }}
      >
        <IconButton onClick={onArrowClick}>
          <ExpandMoreOutlinedIcon
            sx={{
              fill: chevronColor,
              fontSize: 20,
              transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
              transition: "transform 0.2s ease"
            }}
          />
        </IconButton>
        <Stack
          direction="row"
          alignItems="center"
          gap="5px"
          onClick={onTitleClick}
          sx={{
            flex: 1,
            minWidth: 0,
            cursor: "pointer"
          }}
        >
          {icon}
          <Typography
            sx={{
              color: labelColor,
              fontWeight: isOpen ? 700 : 500,
              fontSize: "16px"
            }}
          >
            {title}
          </Typography>
        </Stack>
      </Stack>
      <Collapse
        sx={{
          overflow: "hidden",
          maxHeight: "100%"
        }}
        in={isOpen}
        timeout={300}
        unmountOnExit
      >
        <Box
          sx={{
            width: "100%",
            overflow: "auto",
            ...(availableHeight && { height: availableHeight })
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Stack>
  );
};
